export const successToastStyle = {
  background: "#DEF0E7",
  color: "#209860",
  borderColor: "1px solid #209860",
};

export const errorToastStyle = {
  background: "#F6D7D9",
  color: "#F85F6A",
  borderColor: "1px solid #209860",
};
